import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateDataset } from "../../../../../redux/dataset/datasetSlice";

export default function SegmentPopup({
  segment,
  onClose,
  onSave,
  onDelete,
  multipleSelected,
}) {
  const [speaker, setSpeaker] = useState(segment.speaker);
  const [text, setText] = useState(segment.text);
  const [isAudience, setIsAudience] = useState(false);

  const dispatch = useDispatch();

  const allSpeakers = useSelector(
    (state) => state.datasetSlice.dataset.speakers
  );

  const [sortedSpeakers, setSortedSpeakers] = useState(allSpeakers);

  useEffect(() => {
    const sorted = [...allSpeakers].sort();
    setSortedSpeakers(sorted);
  }, [allSpeakers]);

  function reverseRenderWithLineBreaks(htmlText) {
    return htmlText.replace(/<br\s*\/?>/g, "\n");
  }

  const handleSave = () => {
    const speakerToSave = isAudience ? "Audience" : speaker;
    onSave(segment.id, speakerToSave, reverseRenderWithLineBreaks(text));
    onClose();

    if (speakerToSave === "Audience") {
      if (!allSpeakers.includes(speakerToSave)) {
        dispatch(updateDataset({ speakers: [...allSpeakers, speakerToSave] }));
      }
    }
  };

  const handleDelete = () => {
    onDelete(segment.id);
    onClose();
  };

  const handleKeyDown = (event) => {
    if ((event.key === "Enter" || event.keyCode === 13) && !event.shiftKey) {
      handleSave();
      event.preventDefault();
    } else if (
      (event.key === "Enter" || event.keyCode === 13) &&
      event.shiftKey
    ) {
      const startPos = event.target.selectionStart;
      const endPos = event.target.selectionEnd;
      const content = event.target.value;
      const newContent =
        content.substring(0, startPos) + "\n" + content.substring(endPos);
      setText(newContent);
      event.preventDefault();

      // Use setTimeout to delay cursor setting
      setTimeout(() => {
        event.target.selectionStart = startPos + 1;
        event.target.selectionEnd = startPos + 1;
      }, 0);
    } else if (event.key === "Escape" || event.keyCode === 27) {
      onClose();
    }
  };

  return (
    <>
      <div className={styles.popupBackdrop} onClick={onClose}></div>
      <div className={styles.segmentPopup}>
        <h3>Edit Segment</h3>

        <label htmlFor="audienceSpeaking" className={styles.audience}>
          Audience speaking?
          <input
            type="checkbox"
            id="audienceSpeaking"
            name="audienceSpeaking"
            checked={isAudience}
            onChange={(e) => setIsAudience(e.target.checked)}
          />
        </label>
        <label htmlFor="speakers">
          Speaker:
          <select
            name="speakers"
            className={styles.speakersDropdown}
            onChange={(e) => setSpeaker(e.target.value)}
            disabled={isAudience}
          >
            <option value={speaker}>Select a speaker</option>
            {sortedSpeakers.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>
        {!multipleSelected && (
          <label htmlFor="text">
            Text:
            <textarea
              name={"text"}
              onKeyDown={handleKeyDown}
              value={text}
              onChange={(e) => setText(e.target.value)}
              rows={4}
            />
          </label>
        )}

        <button onClick={handleSave} className={styles.save}>
          Save
        </button>
        <button onClick={handleDelete} className={styles.delete}>
          Delete
        </button>
        <button onClick={onClose} className={styles.close}>
          Close
        </button>
      </div>
    </>
  );
}
